// Shared CRM Next vocabulary.
//
// SOURCES / TIERS mirror the TextChoices on crm.models.Opportunity. They used
// to live only in NewLeadModal; the Person Detail card now offers the same
// choices, so they are canonical here rather than copied per screen.

export const SOURCES = [
    ['WEB', 'Web'], ['REFERRAL', 'Referral'], ['AUTOTRADER', 'AutoTrader'],
    ['WALK_IN', 'Walk-in'], ['RENEWAL', 'Renewal'], ['OTHER', 'Other'],
]

export const TIERS = [['HOT', 'Hot'], ['WARM', 'Warm'], ['COLD', 'Cold']]

// "WARM" -> "Warm". Blank in, blank out — callers render their own '—'.
export const cap = (s) => (s ? s.charAt(0) + s.slice(1).toLowerCase() : '')

// Salesperson options from profileState.account_users, which the backend
// already scopes to the requester's own account.
//
// The label precedence matches ListDealsPage's buildUserOptions, but this keeps
// the id: that helper returns bare label strings led by "All" for a text
// filter, and a select has to map its choice back to a user. account_users
// currently carries {id, email, username}, so the earlier keys are fallbacks
// for a payload that gains real names later. Entries without an id (the plain
// strings buildUserOptions tolerates) can't be selected, so they are dropped.
export const salespersonOptions = (accountUsers) => (accountUsers ?? [])
    .filter((u) => u && typeof u === 'object' && u.id != null)
    .map((u) => ({
        id: u.id,
        label: u.name
            || u.full_name
            || [u.first_name, u.last_name].filter(Boolean).join(' ')
            || u.email
            || u.username
            || String(u.id),
    }))
